import { render } from "./TemplateEvent.vue?vue&type=template&id=90e0bc24&scoped=true"
import script from "./TemplateEvent.vue?vue&type=script&lang=js"
export * from "./TemplateEvent.vue?vue&type=script&lang=js"

import "./TemplateEvent.vue?vue&type=style&index=0&id=90e0bc24&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e0bc24"]])

export default __exports__